import React from "react";
import Link from "gatsby-link";

import "./Footer.css";

export default class Footer extends React.Component
{
    render () {
        return (
            <footer>
                <div>
                    Risag e.U. <span className="is-hidden-sm">– Allgäuer Günther – <Link to="/">www.risag.eu</Link></span>
                </div>

                <div>
                    <Link to="/kontakt/">Kontakt und Impressum</Link>
                </div>
            </footer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.jsx